import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import './Navbar.css';

function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const [activeSection, setActiveSection] = useState('hero');
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const sections = ['hero', 'about', 'portfolio', 'testimonials', 'team', 'contact'];

  useEffect(() => {
    if (location.pathname !== '/') return;

    const observerOptions = {
      root: null,
      rootMargin: '-50% 0px -50% 0px', // highlight when section is near center
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, observerOptions);

    sections.forEach((id) => {
      const section = document.getElementById(id);
      if (section) observer.observe(section);
    });

    return () => {
      sections.forEach((id) => {
        const section = document.getElementById(id);
        if (section) observer.unobserve(section);
      });
    };
  }, [location.pathname]);

  const goToSection = (sectionId) => {
    setIsMobileNavOpen(false);
    if (location.pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    } else {
      sessionStorage.setItem('scrollTarget', sectionId);
      navigate('/');
    }
  };

  const isActive = (sectionId) => activeSection === sectionId;

  const toggleMobileNav = () => {
    setIsMobileNavOpen((prev) => !prev);
    document.body.classList.toggle('mobile-nav-active');
  };

  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container d-flex align-items-center justify-content-between">
        <Link to="/" className="logo d-flex align-items-center me-auto me-lg-0">
          <h1 className="sitename">ABCD International Family</h1>
        </Link>

        <nav id="navmenu" className="navmenu">
          <ul>
            {sections.map((sec) => (
              <li key={sec}>
                <a
                  href="#!"
                  className={isActive(sec) ? 'active' : ''}
                  onClick={() => goToSection(sec)}
                >
                  {sec.charAt(0).toUpperCase() + sec.slice(1)}
                </a>
              </li>
            ))}
          </ul>
          <i
            className={`mobile-nav-toggle d-xl-none bi ${isMobileNavOpen ? 'bi-x' : 'bi-list'}`}
            onClick={toggleMobileNav}
          ></i>
        </nav>

        {!user ? (
          <Link to="/login" className="btn-getstarted">Sign In</Link>
        ) : (
          <div className="nav-auth">
            <Link to="/profile" className="profile-chip">
              <span className="profile-chip__avatar">
                {(user.fullName || user.name || 'U').charAt(0).toUpperCase()}
              </span>
              <span className="profile-chip__name">{user.fullName || user.name}</span>
            </Link>
            <button className="btn btn-getstarted btn-sm" onClick={logout}>Log out</button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Navbar;
